import type { MessageArgs, MessageText, PlainMessageId } from './ids';
import { formatCatalogMessage, getIntl } from './internal/intl';

// Plain ids only: a message with rich-text tags renders nodes, so it goes through <Message />.
export function msg<K extends PlainMessageId>(id: K, ...args: MessageArgs<K>): MessageText {
  return formatCatalogMessage(getIntl(), id, args[0]);
}
